import axios from "axios";

const API_BASE_URL = (
  process.env.REACT_APP_API_URL ||
  "https://api.bsangam.com"
).replace(/\/$/, "");

const TASK_BASE_URL = `${API_BASE_URL}/tasks`;
const USER_BASE_URL = `${API_BASE_URL}/user`;

// ==========================
// GET FORM DETAILS
// ==========================
export const getTaskDetailsApi = async (
  taskId: number | string
) => {
  try {
    const res = await axios.get(
      `${TASK_BASE_URL}/${taskId}`
    );

    return res.data;
  } catch (error: any) {
    return {
      success: false,
      data: null,
      message:
        error?.response?.data?.message ||
        "Unable to load form details",
    };
  }
};

// ==========================
// UPLOAD TASK FILE
// ==========================
export const uploadTaskFileApi = async (
  payload: {
    file: File;
    task_id: number | string;
    field_id: number | string;
    uploaded_by: number | string;
  }
) => {
  try {
    const formData = new FormData();

    formData.append("file", payload.file);
    formData.append(
      "task_id",
      String(payload.task_id)
    );
    formData.append(
      "field_id",
      String(payload.field_id)
    );
    formData.append(
      "uploaded_by",
      String(payload.uploaded_by)
    );

    const res = await axios.post(
      `${TASK_BASE_URL}/upload-file`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return res.data;
  } catch (error: any) {
    return {
      success: false,
      data: null,
      message:
        error?.response?.data?.message ||
        "Unable to upload file",
    };
  }
};

// ==========================
// SUBMIT TASK RESPONSE
// ==========================
export const submitTaskResponseApi = async (
  taskId: number | string,
  payload: {
    user_id: number | string;
    answers: any[];
  }
) => {
  try {
    const res = await axios.post(
      `${TASK_BASE_URL}/${taskId}/response`,
      payload
    );

    return res.data;
  } catch (error: any) {
    return {
      success: false,
      data: null,
      message:
        error?.response?.data?.message ||
        "Unable to submit form",
    };
  }
};

// ==========================
// GET USER TASK RESPONSES
// ==========================
export const getTaskResponseApi = async (
  taskId: number | string,
  userId: number | string
) => {
  try {
    const res = await axios.get(
      `${TASK_BASE_URL}/${taskId}/response`,
      {
        params: {
          user_id: userId,
        },
      }
    );

    return res.data;
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message:
        error?.response?.data?.message ||
        "Unable to load submitted response",
    };
  }
};

// ==========================
// GET PUBLIC FORMS
// ==========================
export const getPublicFormsApi = async (
  params: {
    search?: string;
    status?: string;
    page?: number;
    limit?: number;
  },
  signal?: AbortSignal
) => {
  try {
    const res = await axios.get(
      `${TASK_BASE_URL}/public/forms`,
      {
        params,
        signal,
      }
    );

    return res.data;
  } catch (error: any) {
    if (
      error?.name === "CanceledError" ||
      error?.code === "ERR_CANCELED"
    ) {
      throw error;
    }

    return {
      success: false,
      data: [],
      message:
        error?.response?.data?.message ||
        "Unable to fetch public forms",
    };
  }
};

// ==========================
// GET ASSIGNED FORMS
// ==========================
export const getAssignedFormsApi = async (
  params: {
    user_id: number | string;
    search?: string;
    task_status?: string;
    submission_status?: string;
    page?: number;
    limit?: number;
  }
) => {
  try {
    const res = await axios.get(
      `${USER_BASE_URL}/forms/assigned`,
      {
        params,
      }
    );

    return res.data;
  } catch (error: any) {
    return {
      success: false,
      data: [],
      pagination: {
        total: 0,
        page: params.page || 1,
        limit: params.limit || 10,
        totalPages: 0,
      },
      message:
        error?.response?.data?.message ||
        "Unable to fetch assigned forms",
    };
  }
};










// ==========================
// GET PUBLIC FORM BY SLUG
// ==========================
export const getPublicFormBySlugApi = async (
  slug: string
) => {
  try {
    const res = await axios.get(
      `${TASK_BASE_URL}/public/forms/${encodeURIComponent(slug)}`
    );

    return res.data;
  } catch (error: any) {
    return {
      success: false,
      status: false,
      data: null,
      message:
        error?.response?.data?.message ||
        "Unable to load this public form.",
    };
  }
};

// ==========================
// SUBMIT PUBLIC FORM RESPONSE
// ==========================
export const submitPublicFormResponseApi = async (
  slug: string,
  formData: FormData
) => {
  try {
    const res = await axios.post(
      `${TASK_BASE_URL}/public/forms/${encodeURIComponent(slug)}/responses`,
      formData
    );

    return res.data;
  } catch (error: any) {
    return {
      success: false,
      status: false,
      data: null,
      message:
        error?.response?.data?.message ||
        "Unable to submit the form.",
    };
  }
};
